export default __webpack_public_path__ + "static/media/Usa.2b7f2f80.jpg";